// Helper auth guard terpusat: cek localStorage token + expired.
// Dipakai Admin layout & index.js. Expired disimpan sebagai epoch ms
// (ditulis saat login di SignIn.js: now + 2 jam).

export function isAuthenticated() {
  try {
    const token = localStorage.getItem("token");
    if (!token) return false;
    const expired = localStorage.getItem("expired");
    if (expired && Number(expired) < Date.now()) {
      clearAuth();
      return false;
    }
    return true;
  } catch {
    return false;
  }
}

export function clearAuth() {
  ["token", "role", "nama", "kd_unit", "nip", "expired"].forEach((k) => {
    try {
      localStorage.removeItem(k);
    } catch {
      /* abaikan */
    }
  });
}
